module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/right-2-5f15c0837cfdd04cda42601048df992a.svg";